<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="user.nome"
    label="Responsável"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    @focus="onFocus"
    v-bind="$attrs"
  />
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import UsuarioService from '@/modules/entidades/usuario-service';

const DEFAULT_LIMIT = 30;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
    companyId: [Number, String],
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
    companyId(newValue) {
      if (!newValue) {
        return;
      }
      this.debounceSearch();
    },
  },
  methods: {
    searchResponsaveis(val) {
      if (this.localValue && this.localValue.user.nome === val) {
        return;
      }

      const searchTerm = val ? val.toLowerCase() : '';

      this.loading = true;
      UsuarioService.getUsuarios(this.companyId, {
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `nome like "%${searchTerm}%" order by nome`,
      })
        .then((response) => {
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onFocus() {
      this.debounceSearch();
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchResponsaveis, 1000);
    if (this.value) {
      this.items = [this.value];
    }
  },
};
</script>
